export default __webpack_public_path__ + "static/media/icon-todo.2fde8d86.svg";